const c = {
  name: "Acquiring",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,14c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6s6-2.7,6-6C26,16.7,23.3,14,20,14z M20,24c-2.2,0-4-1.8-4-4
			s1.8-4,4-4s4,1.8,4,4S22.2,24,20,24z"/>
		<path class="st0" d="M31.5,11.5c0,0.6-0.2,1.1-0.5,1.6c3.2,5.1,2.5,11.7-1.8,16.1C26.7,31.7,23.3,33,20,33c-2.4,0-4.8-0.7-6.9-2
			c-0.5,0.3-1,0.5-1.6,0.5c-0.8,0-1.5-0.3-2.1-0.9c-1-1-1.1-2.6-0.4-3.7c-3.2-5.1-2.5-11.7,1.8-16.1c4.3-4.3,11-5,16.1-1.8
			c1.2-0.7,2.7-0.6,3.7,0.4C31.2,10,31.5,10.7,31.5,11.5z M14.4,29.4c4.3,2.6,9.8,1.9,13.4-1.7c3.6-3.6,4.2-9.1,1.7-13.4
			c-0.3,0.1-0.6,0.2-0.9,0.2c-0.8,0-1.5-0.3-2.1-0.9c-0.8-0.8-1.1-2-0.7-3.1c-4.3-2.6-9.8-1.9-13.4,1.7c-3.6,3.6-4.2,9.1-1.6,13.4
			c1-0.3,2.3-0.1,3.1,0.7C14.5,27.2,14.7,28.4,14.4,29.4z M10.8,29.2c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4
			c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3C10.4,28.2,10.4,28.8,10.8,29.2z M28.5,10.5c-0.3,0-0.5,0.1-0.7,0.3c0,0,0,0,0,0
			c0,0,0,0,0,0.1c-0.3,0.4-0.3,1,0.1,1.3c0.4,0.4,1,0.4,1.3,0.1l0.1-0.1c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7
			C29,10.6,28.7,10.5,28.5,10.5z"/>
		<path class="st0" d="M34.1,5.9C27.3-0.9,16.9-1.9,8.9,3.4c-1.5-1.1-3.8-1-5.2,0.4C3,4.5,2.6,5.5,2.6,6.6c0,0.9,0.3,1.7,0.8,2.4
			c-5.3,7.9-4.3,18.4,2.5,25.2C9.8,38,14.9,40,20,40c3.8,0,7.7-1.1,11.1-3.4c0.7,0.5,1.5,0.8,2.4,0.8c1,0,2-0.4,2.8-1.2
			c1.4-1.4,1.5-3.6,0.4-5.2C41.9,23.1,40.9,12.7,34.1,5.9z M34.8,34.8c-0.8,0.8-2,0.8-2.8,0c-0.8-0.8-0.8-2,0-2.8
			c0.4-0.4,0.9-0.6,1.4-0.6s1,0.2,1.4,0.6C35.6,32.8,35.6,34,34.8,34.8z M7.3,32.7c-6.1-6.1-7-15.4-2.3-22.5
			c0.5,0.2,1.1,0.4,1.6,0.4c1,0,2-0.4,2.8-1.2c1.2-1.2,1.5-3,0.8-4.5c7.1-4.6,16.4-3.7,22.5,2.3c6.1,6.1,7,15.4,2.3,22.5
			c-1.5-0.7-3.3-0.4-4.5,0.8c-1.2,1.2-1.5,3-0.8,4.5C22.7,39.7,13.4,38.8,7.3,32.7z M5.2,5.2C5.5,4.8,6,4.6,6.6,4.6
			c0.5,0,1,0.2,1.4,0.6c0.8,0.8,0.8,2,0,2.8c-0.8,0.8-2,0.8-2.8,0C4.8,7.6,4.6,7.1,4.6,6.6S4.8,5.5,5.2,5.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Acquiring
};
